import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { RouteEnum } from '@shared/services/route-enum';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header-component',
    templateUrl: './header.component.html',
    styleUrls: [],
})
export class HeaderComponent {
    @Output() toggleRightMenuMobile = new EventEmitter<boolean>();
    @Output() toggleLeftMenuMobile = new EventEmitter<boolean>();
    @Output() toggleNoscroll = new EventEmitter<boolean>();
    @ViewChild('appHeaderDocuments') appHeaderDocuments;
    pushedRight = false;
    pushedLeft = false;

    constructor(private router: Router) {
        // nothing
    }

    hideEspaceDoc(): void {
        if (this.appHeaderDocuments.espaceDocVisibility) {
            this.appHeaderDocuments.espaceDocVisibility = false;
            this.appHeaderDocuments.toggleDocuments.emit();
        }
    }

    isAuthorizedForDisplay(): boolean {
        return !this.router.isActive(RouteEnum.otpConnexion, false);
    }
}
